<div class="flip-card">
  <div class="flip-card-inner" [ngClass]="flipped ? 'flip-card-true' : null">
    <mat-card class="widget-card flip-card-front">
      <mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title col-auto">Meteorologia</div>
          <div class="flex-fill"></div>
          <mat-button-toggle-group
            [value]="selectedWindUnit"
            class="mr-2 unit-toggle"
            (change)="windUnitChanged($event.value)"
          >
            <mat-button-toggle value="nós">nós</mat-button-toggle>
            <mat-button-toggle value="m/s">m/s</mat-button-toggle>
            <mat-button-toggle value="km/h">km/h</mat-button-toggle>
          </mat-button-toggle-group>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = true">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content>
        <div class="row d-flex align-items-center" style="min-height: 250px">
          <div
            class="col-4 col-md-3 col-lg-3 col-xl-2 d-flex align-items-center justify-content-center"
            style="height: 100%; width: 100%"
          >
            <ng-lottie
              width="300px"
              height="250px"
              containerClass="moving-box"
              [styles]="styles"
              [options]="options"
            ></ng-lottie>
          </div>

          <!-- Last values box -->
          <div class="col-8 col-md-9 col-lg-9 col-xl-4" [ngClass]="isLastValuesModeled ? '' : 'modeled-box'">
            <div class="row d-flex justify-content-center align-items-center mb-2" [ngClass]="isLastValuesModeled ? 'small-info' : ''">
              
              <b class="small-info-bold">Valores {{ isLastValuesModeled ? 'previstos' : 'medidos' }}</b>
              <span class="small-info">
                {{ isLastValuesModeled ? 'para' : 'a' }} {{ lastValuesDate | date : "dd/MM/yyyy 'às' HH:mm" : "en" }}
              </span>

              <i
                class="fas fa-exclamation-triangle ml-2"
                *ngIf="!isDataUnderTolerance()"
                matTooltip="A comunicação com a fonte de dados encontra-se temporariamente indisponível"
                style="color: #FFD43B; cursor: pointer"
              ></i>
              <i
                (click)="flipped = true"
                *ngIf="isDataUnderTolerance()"
                class="fas fa-info-circle ml-2 fa-lg"
                style="color: white; cursor: pointer"
              ></i>
            </div>
            
            <!-- Weather box -->
            <div 
              *ngFor="let row of parameterRows" 
              class="row" 
              [ngClass]="{ 'reduced-width': isRowReducedWidth(row) }"
              style="margin-bottom: 10px;" 
            >
              <div class="col pr-0 parameter-title" *ngFor="let col of row.columns">
                  {{ col.title }}:
                  <div class="value d-flex justify-content-center align-items-center">
                    <i [ngClass]="col.icon" [style.transform]="col.extraPipe ? 'rotate(' + getRotation(1.5) + ')' : ''"></i>
                    <i  class="theme-fa-accent"></i>
                    <span>
                      <span *ngIf="col.extraPipe">
                        {{ mappedData.get(col.index)[0] | getSerieValue }}
                        {{ mappedData.get(col.index)[0] | directionCompassRose }}
                      </span>
                      <span *ngIf="col.isWind">
                        {{ mappedData.get(col.index)[0] | getSerieValue: selectedWindUnit }}
                      </span>
                      <span *ngIf="!(col.isWind || col.extraPipe)">
                        {{ mappedData.get(col.index)[0] | getSerieValue }}
                      </span>
                    </span>
                  </div>
              </div>
            </div>
          </div>

          <!-- Weather for the next days -->
          <div class="col-12 col-md-12 col-lg-12 col-xl-6 mt-xl-1 mt-3">
            <div class="row d-flex justify-content-center">
              <div
                class="col-2"
                *ngFor="let item of weatherValues; let i = index"
              >
                <div>
                  <p>{{ i | dayOfWeek }}</p>
                  <i
                    [ngClass]="getWeatherStateIcon(item.weatherState)"
                    style="color: white; font-size: 35px; margin-bottom: 10px"
                  ></i>
                  <p class="d-flex align-items-center justify-content-center">
                    <i
                      class="wi wi-direction-up"
                      style="font-size: 20px; margin-right: 5px"
                    ></i
                    >{{ item.maxTemp | number : "1.1-1" : "en" }} ºC
                  </p>
                  <p
                    class="d-flex align-items-center justify-content-center"
                    style="color: rgb(111, 194, 233)"
                  >
                    <i
                      class="wi wi-direction-down"
                      style="
                        font-size: 20px;
                        margin-right: 5px;
                        color: rgb(111, 194, 233);
                      "
                    ></i
                    >{{ item.minTemp | number : "1.1-1" : "en" }} ºC
                  </p>
                  <i
                    class="fas fa-location-circle theme-fa-accent mb-2"
                    [style.transform]="'rotate(' + add180(item.windDir) + 'deg)'"
                    style="font-size: 30px; color: white"
                  ></i>
                  <p>
                    {{ item.windDir | number : "0.0-0" : "en" }}º
                    {{ item.windDir | directionCompassRose }}
                  </p>
                  <p>
                    {{ item.windSpeed | number : "1.1-1" : "en"
                    }}<span style="color: rgba(255, 255, 255, 0.486)">{{
                      selectedWindUnit
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
            <span class="col-12 small-info m-0"
              >Valores previstos. Intensidade e direção do vento às 12h de
              cada dia</span
            >
          </div>
        </div>

        <p class="sub-title mt-2 mt-lg-0">Previsão</p>
        <hr />
        <div
          style="
            height: 450px;
            background-color: rgba(0, 0, 0, 0.5);
            margin: -10px;
          "
        >
          <div id="windChart" style="width: 100%; height: 100%"></div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="widget-card flip-card-back"
      ><mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title-negative col-auto">Meteorologia</div>
          <div class="flex-fill"></div>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = false">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content><app-wind-info></app-wind-info> </mat-card-content
    ></mat-card>
  </div>
</div>
